
import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from '../../../sushi'
import { BIGNUMBER_FMT } from '../../../constants/bakery'
import useBlock from '../../../hooks/bakery/useBlock'
import {  NFTTYPE } from '../../../constants/bakery/nft'
import usePokerCardRoi from '../../../hooks/nft/usePokerCardRoi'
import { usePrice } from '../../../hooks/usePrice'
import useYam from '../../../hooks/bakery/useYam'
import {
  getWethContract,
  getPokerBnbBlpContract,
  getPokerContract
} from '../../../sushi/utils'

const ArtworkLevel = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  width: auto;
  height: 17px;
  font-size: 14px;
  justify-content: space-between;
  flex-shrink: 1;
  flex-grow: 1;
  min-width: 95px;
`

export default function InfoSolt ({artwork}: {artwork: any}) {
  const yam = useYam()
  const theme = useContext(ThemeContext)
  // 计算rio
  const currentBlock = useBlock()
  const pokerBnbPrice = usePrice(getPokerBnbBlpContract(yam), getPokerContract(yam), getWethContract(yam))
  const pokerBnbPriceFormat = pokerBnbPrice ? pokerBnbPrice.toNumber() : 0
  const pokerRoi = usePokerCardRoi(currentBlock, NFTTYPE.POKER_V3, artwork.attributes.stakingPower,pokerBnbPriceFormat)
  const roi  = pokerRoi || new BigNumber(0)
  return (
    <>
      {
        artwork && artwork.attributes ?
        <>
          <ArtworkLevel>
            <Text color={theme.bsText29}>APY：</Text>
            <Text fontSize={16} color={theme.bsText14} fontFamily="Roboto-Bold" marginTop="6px">
            {
              roi && !roi.isNaN() && roi.gt(0)
                  ? roi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT) + '%'
                  : '-'
            }
            </Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text color={theme.bsText29}>Staking Power：</Text>
            <Text fontSize={16} color={theme.bsText14} fontFamily="Roboto-Bold" marginTop="6px">{ artwork.attributes.stakingPower ? artwork.attributes.stakingPower : '-' }</Text>
          </ArtworkLevel>
        </> : null
      }
    </>
  )
}
